const countDescendantZones = (zones = [], zoneId) => {
  if (zoneId == null || !Array.isArray(zones) || !zones.length) return 0;
  const childrenByParent = new Map();
  zones.forEach((zone) => {
    const parentKey = zone?.parentId == null ? null : `${zone.parentId}`;
    if (!parentKey) return;
    const next = childrenByParent.get(parentKey) || [];
    next.push(`${zone.id}`);
    childrenByParent.set(parentKey, next);
  });

  let count = 0;
  const stack = [`${zoneId}`];
  while (stack.length) {
    const current = stack.pop();
    const children = childrenByParent.get(current) || [];
    count += children.length;
    children.forEach((childKey) => stack.push(childKey));
  }
  return count;
};

const buildDeleteZoneConfirmMessage = (zones = [], zoneId) => {
  const childCount = countDescendantZones(zones, zoneId);
  if (childCount > 0) {
    return `Delete this parent zone? This will also delete ${childCount} child zone${
      childCount === 1 ? '' : 's'
    }. This cannot be undone.`;
  }
  return 'Delete this zone? This cannot be undone.';
};

export const deleteZoneWithConfirmation = async ({
  activeZone,
  zones,
  deleteZone,
  confirm,
  showAlert,
}) => {
  if (!activeZone || typeof deleteZone !== 'function') return false;
  const confirmMessage = buildDeleteZoneConfirmMessage(zones, activeZone.id);
  const didConfirm =
    typeof confirm === 'function'
      ? await confirm({
          title: 'Delete zone',
          message: confirmMessage,
          confirmLabel: 'Delete',
          cancelLabel: 'Cancel',
          confirmVariant: 'danger',
          cancelVariant: 'primary',
          showCancel: true,
        })
      : false;
  if (!didConfirm) return false;
  try {
    await deleteZone(activeZone.id);
    return true;
  } catch (error) {
    console.error('Failed to delete zone:', error);
    if (typeof showAlert === 'function') {
      await showAlert({
        title: 'Delete failed',
        message: 'Unable to delete zone right now. Please try again.',
        confirmLabel: 'OK',
        confirmVariant: 'primary',
        showCancel: false,
      });
    }
    return false;
  }
};
